<template>
    <div>
        <section class="section">
            <div class="container">
                <div class="columns">
                    <div class="column is-3"></div>
                    <div class="column is-6">
                        <div id="meme-card" class="card">
                            <div class="card-image">
                                <div v-if="image == null">
                                    <Spinner size="big" />
                                    <br />
                                    <p style="text-align: center;">Generating meme...</p>
                                </div>

                                <div v-if="image != null">
                                    <figure id="meme" class="image is-3by5">
                                        <img :src="image" alt="Generated meme">
                                    </figure>

                                    <div class="columns is-centered">
                                        <div class="column has-text-centered">
                                            <button @click="generateMeme" class="button is-primary">Generate a new meme</button>
                                        </div>
                                    </div>

                                    <div class="columns is-centered">
                                        <div class="column is-2"></div>
                                        <div class="column has-text-centered">
                                            <b-field label="Creativity">
                                                <b-slider v-model="temperature"></b-slider>
                                            </b-field>
                                        </div>
                                        <div class="column is-2"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="column is-3"></div>
                </div>
            </div>
        </section>

        <footer class="footer">
            <div class="content has-text-centered">
                <p>
                    Created with ❤️ in Maastricht 🇳🇱
                </p>
            </div>
        </footer>
    </div>
</template>

<script>

const axios = require("axios");
import Spinner from 'vue-simple-spinner'


export default {
  name: "Generator",
  components: {
    Spinner
  },
  data: function () {
    return {
        image: null,
        temperature: 50,
        api: axios.create({
            baseURL: 'http://142.93.142.151:5000/',
        })
    }
  },
  mounted: function () {
    this.generateMeme();
  },
  methods: {
    generateMeme: function () {
        let view = this;
        this.image = null;

        this.api.get(`meme/drake/${this.temperature}`)
            .then(function (response) {
                view.image = `data:image/png;base64, ${response.data.image}`;
            })
            .catch(function (error) {
                console.log(error);

                view.$buefy.toast.open({
                    duration: 3000,
                    message: "Something went wrong, please retry later",
                    position: "is-top",
                    type: "is-danger"
                })
            });
    }
  }
};

</script>

<style>

#meme-card {
    padding: 16px;
    box-shadow: 0 0.5em 1.5em -0.125em rgba(10, 10, 10, 0.25), 0 0px 0 1px rgba(10, 10, 10, 0.02);
}

#meme {
    margin-bottom: 16px;
}

.footer {
    padding-bottom: 3rem;
}

</style>